import { useState } from 'react';
import ReportsNav from '../../components/ReportsNav';
import { reportsApi, type VatDeclarationDto } from '../../api/reports';
import MoneyCell from '../../components/MoneyCell';
import LoadingSpinner from '../../components/LoadingSpinner';

export default function VatDeclaration() {
  const [from, setFrom] = useState(() => {
    const d = new Date();
    d.setMonth(d.getMonth() - 3);
    d.setDate(1);
    return d.toISOString().slice(0, 10);
  });
  const [to, setTo] = useState(() => new Date().toISOString().slice(0, 10));
  const [data, setData] = useState<VatDeclarationDto | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleGenerate = async () => {
    setLoading(true);
    setError('');
    try {
      const result = await reportsApi.vatDeclaration({ from, to });
      setData(result);
    } catch (e: any) {
      setError(e.message || 'Failed to generate VAT declaration');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-4">
      <ReportsNav />
      <h1>PVM deklaracija (FR0572)</h1>

      <div className="filters" style={{ display: 'flex', gap: '1rem', alignItems: 'center', marginBottom: '1rem' }}>
        <label>
          Laikotarpis nuo: <input type="date" value={from} onChange={e => setFrom(e.target.value)} />
        </label>
        <label>
          Laikotarpis iki: <input type="date" value={to} onChange={e => setTo(e.target.value)} />
        </label>
        <button onClick={handleGenerate} disabled={loading}>
          {loading ? <LoadingSpinner /> : 'Generuoti deklaraciją'}
        </button>
      </div>

      {error && <div className="error-message">{error}</div>}

      {data && (
        <>
          {/* Summary */}
          <div className="card" style={{ marginBottom: '1rem' }}>
            <h2>Pardavimų PVM</h2>
            <table className="data-table">
              <thead>
                <tr><th>Tarifas</th><th style={{ textAlign: 'right' }}>Apmokestinama suma</th><th style={{ textAlign: 'right' }}>PVM suma</th></tr>
              </thead>
              <tbody>
                <tr><td>21% (Standard)</td><td style={{ textAlign: 'right' }}><MoneyCell value={data.totalSalesExcludingVat} /></td><td style={{ textAlign: 'right' }}><MoneyCell value={data.salesVat21} /></td></tr>
                <tr><td>9% (Reduced)</td><td style={{ textAlign: 'right' }}>-</td><td style={{ textAlign: 'right' }}><MoneyCell value={data.salesVat9} /></td></tr>
                <tr><td>5% (Super-reduced)</td><td style={{ textAlign: 'right' }}>-</td><td style={{ textAlign: 'right' }}><MoneyCell value={data.salesVat5} /></td></tr>
                <tr><td>0% (Zero)</td><td style={{ textAlign: 'right' }}><MoneyCell value={data.salesVat0} /></td><td style={{ textAlign: 'right' }}>-</td></tr>
              </tbody>
              <tfoot>
                <tr className="total-row">
                  <td><strong>Pardavimų PVM iš viso</strong></td>
                  <td></td>
                  <td style={{ textAlign: 'right' }}><strong><MoneyCell value={data.totalSalesVat} /></strong></td>
                </tr>
              </tfoot>
            </table>
          </div>

          <div className="card" style={{ marginBottom: '1rem' }}>
            <h2>Pirkimų PVM</h2>
            <table className="data-table">
              <thead>
                <tr><th>Tarifas</th><th style={{ textAlign: 'right' }}>Apmokestinama suma</th><th style={{ textAlign: 'right' }}>PVM suma</th></tr>
              </thead>
              <tbody>
                <tr><td>21% (Standard)</td><td style={{ textAlign: 'right' }}><MoneyCell value={data.totalPurchasesExcludingVat} /></td><td style={{ textAlign: 'right' }}><MoneyCell value={data.purchaseVat21} /></td></tr>
                <tr><td>9% (Reduced)</td><td style={{ textAlign: 'right' }}>-</td><td style={{ textAlign: 'right' }}><MoneyCell value={data.purchaseVat9} /></td></tr>
                <tr><td>5% (Super-reduced)</td><td style={{ textAlign: 'right' }}>-</td><td style={{ textAlign: 'right' }}><MoneyCell value={data.purchaseVat5} /></td></tr>
              </tbody>
              <tfoot>
                <tr className="total-row">
                  <td><strong>Pirkimų PVM iš viso</strong></td>
                  <td></td>
                  <td style={{ textAlign: 'right' }}><strong><MoneyCell value={data.totalPurchaseVat} /></strong></td>
                </tr>
              </tfoot>
            </table>
          </div>

          <div className="card" style={{ padding: '1rem', backgroundColor: data.netVatPayable >= 0 ? '#f8d7da' : '#d4edda', borderRadius: '4px' }}>
            <h2 style={{ marginBottom: '0.5rem' }}>
              Net VAT {data.netVatPayable >= 0 ? 'Payable' : 'Refundable'}
            </h2>
            <div style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>
              <MoneyCell value={Math.abs(data.netVatPayable)} />
            </div>
          </div>
        </>
      )}
    </div>
  );
}
